$(function() {
    init();

    function init() {
        eventsInit();
    }

    function eventsInit() {
        const form = $("#frm_list_filter");
        const filterFields = form.find(".filter-grid__fields");

        $("#btn_filters_open").on("click", function(e) {
            e.preventDefault();
            $("#btn_filters_open").hide();
            $("#btn_filters_close").show();
            $("#btn_filters_find").show();
            $("#btn_filters_clear").show();
            filterFields.show();
            form.find("input[name='show']").val(1);
        });

        $("#btn_filters_close").on("click", function(e) {
            e.preventDefault();
            $("#btn_filters_open").show();
            $("#btn_filters_close").hide();
            $("#btn_filters_find").hide();
            $("#btn_filters_clear").hide();
            filterFields.hide();
            form.find("input[name='show']").val(0);
        });

        $("#btn_filters_find").on("click", function(e) {
            e.preventDefault();
            form.submit();
        });
    }
});